import { getSinglePaymentLinkAPI, updateStatusAPI, releaseTemporalImputationsAPI } from "../sevices/paymentLinkService";
  
export const getPaymentLink = (id) => async (dispatch) => {
    await dispatch(getSinglePaymentLinkAPI(id));
};
